function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.5 6c.828 0 1.5.672 1.5 1.5S19.328 9 18.5 9H16c0 1.105-.895 2-2 2h-1.5v4.182c1.765.188 3.35 1.366 3.972 3.154.091.26-.047.546-.308.636-.26.091-.546-.047-.636-.308-.478-1.374-1.678-2.291-3.027-2.475L12.5 18.5c0 .276-.224.5-.5.5-.245 0-.45-.177-.492-.41l-.008-.09v-2.311c-.243.033-.486.09-.727.174-1.078.375-1.926 1.223-2.3 2.301-.091.261-.376.399-.637.308-.261-.09-.399-.375-.308-.636.475-1.367 1.55-2.442 2.917-2.917.349-.122.703-.2 1.055-.237V11H10c-1.105 0-2-.895-2-2H5.5C4.672 9 4 8.328 4 7.5S4.672 6 5.5 6h13zM15 9H9c0 .513.386.936.883.993L10 10h4c.513 0 .936-.386.993-.883L15 9zm3.5-2h-13c-.276 0-.5.224-.5.5 0 .245.177.45.41.492L5.5 8h13c.276 0 .5-.224.5-.5 0-.245-.177-.45-.41-.492L18.5 7z"
});

var SvgIconSeat = function SvgIconSeat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-seat.90dcbd42.svg";
export { ForwardRef as ReactComponent };